<template>
    <div class="teachers">
        <teacher-item v-for="teacher in teachers"
        :teacher="teacher" :key="teacher.id">
        </teacher-item>
    </div>
</template>

<script>
import TeacherItem from "@/components/teachers/TeacherItem.vue";

export default {
  name: `CurrentTeachers`,
  props: {
    teachers: Array
  },
  components: {
    TeacherItem
  }
};
</script>

<style>
</style>
